<template>
    <div>
        <el-dialog v-if="isType==2" v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件" custom-class="full_dialog">
            <div class="upFileOutBox clearfix" v-if="fileList.length>0">
                <a class="upFileBox clearfix" v-for="(item,index) in fileList" :key="index+'_index'" @click="download(item)">
                    <div class="upFile">{{item}}</div>
                    <img src="/icon/gl_download.png" class="upFileRemove"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </a>
            </div>
            <img src="/icon/noFiles.png" class="noFiles" v-else/>
        </el-dialog>
        <el-dialog v-else  :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="关联文件" custom-class="full_dialog">
            <div class="upFileOutBox clearfix" v-if="fileList.length>0">
                <a class="upFileBox clearfix" v-for="(item,index) in fileList" :key="index+'_index'" @click="download(item.url)">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/gl_download.png" class="upFileRemove"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </a>
            </div>
            <img src="/icon/noFiles.png" class="noFiles" v-else/>
        </el-dialog>
    </div>
</template>
<style scoped>
    .upFileOutBox .upFileBox{width:100%;margin-bottom:10px;border-radius: 5px;box-shadow: 0 0 5px #ccc;padding:2px 10px;margin-top:10px;display: block;cursor: pointer;transition: 0.1s linear;position: relative;}
    .upFileBox:hover{transform: translateY(-2px);}
    .upFileUnder{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileTop{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;top:0;border-radius: 35px;}
    .upFileLeft{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileRight{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;top:0;border-radius: 35px;}
    .upFileBox:hover .upFileUnder{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileTop{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileLeft{width:0;height:100%;border-left:1px solid #b21111;}
    .upFileBox:hover .upFileRight{width:0;height:100%;border-left:1px solid #b21111;}
    .upFileOutBox .upFile{display: block;float: left;font-size: 14px;}
    .upFileOutBox .upFileRemove{width:15px;height:15px;float:right;cursor:pointer;margin-top:2px;}
    .noFiles{display: block;margin:10px auto;width:150px;}
</style>
<script>
export default {
    props:['files','dialog','isNameType'],
    data(){
        return{
            dialogVisibleFile:false,
            fileList:this.files,
            isType:this.isNameType,
        }
    },
    methods:{
        download(url){
            window.open(url)
        }
    },
    watch:{
        files:function(val){
            this.fileList = val;
        },
        dialog:function(val){
            this.dialogVisibleFile = val;
        },
        isNameType:function(val){
            this.isType = val
        },
        dialogVisibleFile:function(val){
            if(!val){
                this.$emit("closeDialog")
            }
        }
    }
}
</script>